//photosDescriptionLegendeRedigee

import { t } from "i18next";
import { ComputeFieldComponent, unwrapPTag } from "../computeFields";
import { Photography } from "../types";
import { SeparatedList } from "./shared/utils";
import { DimensionsDTO } from "../shared-types";
import { DimensionsFormatting } from "./shared/dimensions";

export const PhotographyDimensionsCF: ComputeFieldComponent<{
  photosDescriptionDimensions: DimensionsDTO;
}> = ({ input, language, ...props }) => (
  <DimensionsFormatting
    language={language}
    {...props}
    input={input.photosDescriptionDimensions}
  />
);

export const PhotographySummaryCF: ComputeFieldComponent<
  Pick<
    Photography,
    | "photosDescriptionTitre"
    | "photosDescriptionLieuDeCreation"
    | "photosDescriptionDate"
    | "photosDescriptionTechnique"
    | "photosDescriptionPhotographe"
    | "photosDescriptionCopyright"
  >
> = ({ input, language, ...props }) => {
  return (
    <SeparatedList
      language={language}
      lineBreak={false}
      commaSeparated={false}
      endWithPeriod={false}
      input={[
        <SeparatedList
          language={language}
          lineBreak={false}
          endWithPeriod
          input={[
            <span
              dangerouslySetInnerHTML={{
                __html: unwrapPTag(input.photosDescriptionTitre),
              }}
            />,
            input.photosDescriptionLieuDeCreation
              ? input.photosDescriptionLieuDeCreation
              : t("computeField.sansLieuAbbrege", { lng: language }),
            input.photosDescriptionDate
              ? input.photosDescriptionDate
              : t("computeField.sansDateAbbrege", { lng: language }),
            input.photosDescriptionTechnique,
          ]}
        />,
        <SeparatedList
          language={language}
          {...props}
          lineBreak={false}
          endWithPeriod={false}
          commaSeparated={false}
          input={[
            input.photosDescriptionPhotographe && (
              <>{t("computeField.photoCredit", { lng: language })} :</>
            ),
            input.photosDescriptionPhotographe,
            input.photosDescriptionCopyright &&
              `© ${input.photosDescriptionCopyright}`,
          ]}
        />,
      ]}
    />
  );
};
